import React from "react";
import Selector from "./Selector";
import { formatMedOptions } from "./helpers";

const MedSelector = ({ medications, value, setParentState, isLoading }) => {
  const handleUpdateMedValue = (val) => {
    if (val == null) {
      setParentState({ medId: null });
    } else {
      setParentState({ medId: val });
    }
  };

  return (
    <Selector
      value={value}
      isLoading={isLoading}
      placeholder="Medication..."
      onUpdateValue={(value) => handleUpdateMedValue(value)}
      options={formatMedOptions(medications)}
    />
  );
};

export default MedSelector;
